import React from 'react'
import Sidebar from '../components/Sidebar'
import ChatRoom from '../components/ChatRoom'
import Navbar from '../components/Navbar'
import CreateGroup from '../components/CreateGroup'
import { useLocation } from 'react-router-dom'
import UserProfile from '../components/UserProfile'

const Dashboard = () => {
    const { pathname } = useLocation();

    const isChat = pathname === '/dashboard/chat' || pathname === '/dashboard';
    const isCreateGroup = pathname === '/dashboard/users';
    const isViewProfile = pathname === '/dashboard/profile';

    const page = (() => {
        if (pathname === '/dashboard/chat') return '';
        if (pathname === '/dashboard/create_group') return 'Group';
        return 'Dashboard';
    })();

    const pageHeading = (() => {
        if (pathname === '/dashboard/chat') return 'Chatify - For Movers';
        if (pathname === '/dashboard/create_group') return 'Create Groups Here';
        return 'Dashboard';
    })();

    return (
        <div className='nk-body npc-apps apps-only has-apps-sidebar npc-apps-chat no-touch nk-nio-theme has-sidebar chat-profile-autohide'>
            <div class="nk-app-root">
                <Sidebar />
                <div className="nk-main ">
                    <div className="nk-wrap ">
                        <Navbar page={page} pageHeading={pageHeading} />
                        
                        {isChat && <ChatRoom />}
                        {isCreateGroup && <CreateGroup />}
                        {isViewProfile && <UserProfile />}

                    </div>
                </div>
            </div>
        </div>
    )
}

export default Dashboard
